module.exports = __webpack_public_path__ + "img/1f922.f4a7b7d.svg";